export default [
  //国家货币列表
  {
    name: "GetCountryCurrencyList",
    url: "/setting/country/list",
    method: "GET",
    mock: false,
  },
  {
    name: "GetSTSToken",
    url: "/osstoken/get",
    method: "GET",
    mock: false,
  },
  {
    name: "GetAppearance",
    url: "/setting/appearance/get",
    method: "GET",
    mock: false,
  },
  {
    name: "GetCompany",
    url: "/setting/company/get",
    method: "GET",
    mock: false,
  },
  {
    name: "GetLanguage",
    url: "/setting/language/list",
    method: "GET",
    mock: false,
  },
  {
    name: "GetSecurity",
    url: "/setting/security/get",
    method: "GET",
    mock: false,
  },
  // 查询全局杠杆列表
  {
    name: "ListGlobalLeverage",
    url: "/setting/global-leverage/list",
    method: "GET",
    mock: false,
  },
  // 获取所有可用货币
  {
    name: "GetCurrencyList",
    url: "/setting/currency/list",
    method: "GET",
    mock: false,
  },
  // 获取滑块验证码的key
  {
    name: "GetAppKey",
    url: "/setting/app-key/get",
    method: "GET",
    mock: false,
  },
  // 发送验证码
  {
    name: "SendEmailVerificationCode",
    url: "/email-verification/send",
    method: "POST",
    mock: false,
  },
  // 注册时校验邮箱是否已注册
  {
    name: "CheckEmailRegistered",
    url: "/email/check-registered",
    method: "POST",
    mock: false,
  },
  // 获取版本号
  {
    name: "GetVersion",
    url: "/setting/version/get",
    method: "GET",
    mock: false,
  },

];
